// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__d-wRy","label":"CheckBox_label__wbnbQ","checkmark":"CheckBox_checkmark__CAUKT"};